import React, { useState } from "react";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import { Accordion, AccordionDetails, AccordionSummary, Card, FormLabel, GridLegacy } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useController, useFormContext } from "react-hook-form";
import Products from "./Products";
import Categories from "./Categories";
import { ExpandMore } from "@mui/icons-material";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import { talenV5 } from "../../../../variables/app";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import { AutocompleteProduct } from "@jamezz/react-components";
import { GET_PRODUCTS } from "../../../../../../Domains/Products/api/productGraphQLApi.ts";
import { RenderOption } from "../../../OptionGroups/Tabs/AutocompleteProductRenderOption.tsx";
import FormFieldTwoColumns from "../../../../components/Forms/Layouts/FormFieldTwoColumns.tsx";

export default function General() {
  const { vestigingId, vestiging, menukaartVestigingId } = useFormContext();

  const [translationsInit, setTranslationsInit] = useState({});

  const {
    field: { value: translationsValue, onChange: translationsOnChange },
  } = useController({ name: "translations" });

  const {
    field: { value: productId, onChange: onChangeProductId },
  } = useController({ name: "product_id" });

  if (Object.keys(translationsInit).length === 0 && translationsValue != null) {
    setTranslationsInit(translationsValue);
  }

  return (
    <>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={12}>
              <FormTextTC
                name={"name"}
                rules={{
                  required: { message: "Is required!", value: true },
                }}
                tDefault={"Name"}
                tKey={"packaging.name"}
              />

              <FormAsyncTC
                async={{
                  url: `core/packagingTypes/search?fields=id as value, name as label&per_page=50&vestiging_id=${vestigingId}`,
                  searchField: "name",
                }}
                name={"packaging_type_id"}
                nullable
                rules={{ required: { value: true, message: "Is required" } }}
                tDefault={"Packaging type"}
                tKey={"packaging.packaging_type"}
              />

              <FormFieldTwoColumns tDefault={"Packaging product"} tKey={"packaging.product"}>
                <AutocompleteProduct
                  multiple={false}
                  menuSalesareaId={menukaartVestigingId}
                  fetchQuery={GET_PRODUCTS}
                  value={productId != null ? Number(productId) : null}
                  onChange={(option) => {
                    onChangeProductId(option.id);
                  }}
                  inputFieldProps={{ sx: { minWidth: 300 } }}
                  renderOption={(props, option) => <RenderOption option={option} />}
                />
              </FormFieldTwoColumns>

              <FormSwitchTC
                name={"add_price_per_order"}
                tDefault={"Costs per order"}
                tKey={"packaging.add_price_per_order"}
              />
              <FormSwitchTC
                name={"add_price_per_item"}
                tDefault={"Costs per item"}
                tKey={"packaging.add_price_per_item"}
              />
            </GridLegacy>
          </GridLegacy>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <TranslationWrapper tDefault={"Translations"} tKey={"Translations"} />
            </AccordionSummary>
            <AccordionDetails>
              {Object.keys(talenV5).map((objKey) => {
                const taal = talenV5[objKey];

                return (
                  <FormTextTC
                    key={objKey}
                    label={
                      <FormLabel>
                        <TranslationWrapper
                          tDefault={"Naam in"}
                          tKey={"packagingType.form.vertalingennaam.label.naam"}
                        />{" "}
                        <TranslationWrapper tDefault={taal.label} tKey={"global." + taal.transKey} />
                      </FormLabel>
                    }
                    name={"translations." + objKey + ".name"}
                  />
                );
              })}
            </AccordionDetails>
          </Accordion>
        </CardBody>
      </Card>
      <Categories />
      <Products />
    </>
  );
}
